import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { getTraderAll, getTraderDetail } from "./requests";
import { ITraderAllParams, ITraderAllResponse, ITraderDetailResponse } from "./types";

export const useGetTraderDetail = (
  address?: string,
  options?: Omit<UseQueryOptions<ITraderDetailResponse, Error>, "queryKey">
) => {
  return useQuery<ITraderDetailResponse, Error>({
    queryKey: ["get-trader-detail", address],
    enabled: !!address,
    queryFn: () => getTraderDetail(address || ""),
    ...(options || {}),
  });
};

export const useGetTraderAll = (
  payload: ITraderAllParams,
  options?: Omit<UseQueryOptions<ITraderAllResponse, Error>, "queryKey">
) => {
  return useQuery<ITraderAllResponse, Error>({
    queryKey: ["get-trader-all", payload?.limit, payload?.page],
    queryFn: () => getTraderAll(payload),
    ...(options || {}),
  });
};
